export default "__VITE_ASSET__KI03CxOD__"